module.exports = __webpack_public_path__ + "img/card-bg-6.8f06d1d7.jpg";